/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Auth0AccountRole } from "./Auth0AccountRole";

/**
 * A trigger's message in the approval queue (or sent, failed…).
 */
export type QueuedSend = {
  id: number;
  template_id: number;
  template_name: string;
  trigger_id?: number | null;
  trigger_label?: string | null;
  person_type: Auth0AccountRole;
  person_id: number;
  person_name: string;
  sms: boolean;
  email: boolean;
  subject?: string | null;
  text?: string | null;
  sms_text?: string | null;
  updated?: boolean;
  wording_changed?: boolean;
  details_changed?: boolean;
  status: QueuedSend.status;
  error?: string | null;
  due_at: string;
  created_at: string;
  sent_at?: string | null;
  decided_by?: string | null;
  decided_at?: string | null;
  /** Waiting for approval, and what it is about no longer holds. */
  no_longer_applies?: string | null;
};

export namespace QueuedSend {
  export enum status {
    WAITING = "waiting",
    QUEUED = "queued",
    SENT = "sent",
    FAILED = "failed",
    DISMISSED = "dismissed",
    SKIPPED = "skipped",
  }
}
